<template>
  <div>
    <div class="mx-0 mt-2 app-grid">
      <v-card
        class="px-5 py-3 rounded-lg"
        elevation="0"
        tile
        v-for="(value, key, index) in tripAnalyticsObject"
        :key="index"
      >
        <v-card-title class="d-flex justify-start pa-0">
          <span
            class="text-capitalize text-center text-caption"
            style="white-space: nowrap"
          >
            {{ key.replace(/_/g, " ") }}
          </span>
        </v-card-title>
        <v-card-text class="d-flex justify-start pa-0">
          <v-btn small class="h-100 btn-box display-lg-none mr-3" depressed>
            <v-icon small :class="`${tripAnalyticsColor[key]}--text`">
              {{ tripAnalyticsIcons[key] }}
            </v-icon>
          </v-btn>
          <h2 class="font-weight-bold d-flex align-center">
            {{ value }}
          </h2>
        </v-card-text>
      </v-card>
    </div>

    <v-row
      class="pa-0 mt-1 ma-0 overflow-y-auto overflow-x-hidden"
      style="height: calc(100vh - 230px)"
      ref="tripCharts"
    >
      <v-col cols="8" class="pa-0">
        <v-row class="ma-0 ma-0">
          <v-col cols="6" class="pl-0 pr-2">
            <v-card
              elevation="0"
              class="rounded-lg h-100 d-flex flex-column"
              style="min-height: 200px"
            >
              <v-card-title class="px-3 py-1">
                <h6 class="text-caption font-weight-bold">Trip Time</h6>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text
                class="pa-0 d-flex align-center justify-center h-100"
              >
                <div v-if="isTripStats">
                  <PieChart
                    :data="timeWiseData"
                    :options="pieChartOptions"
                    :height="pieChartHeight"
                    :width="300"
                  />
                </div>
                <div v-else class="h-100 d-flex align-center justify-center">
                  <span class="text-caption"> Data not available </span>
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="6" class="px-2" v-if="$helper.isCompanyHasItems()">
            <v-card
              elevation="0"
              class="rounded-lg h-100 d-flex flex-column"
              style="min-height: 200px"
            >
              <v-card-title class="px-3 py-1">
                <h6 class="text-caption font-weight-bold">
                  Storage Utilization
                </h6>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text
                class="pa-0 d-flex align-center justify-center h-100"
              >
                <div v-if="isStorageUtilization">
                  <PieChart
                    :data="storageUtilization"
                    :options="pieChartOptions"
                    :height="pieChartHeight - 25"
                    :width="300"
                  />
                </div>
                <div v-else class="h-100 d-flex align-center justify-center">
                  <span class="text-caption"> Data not available </span>
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="6" class="pl-0 pr-2 pt-1">
            <v-card
              elevation="0"
              class="rounded-lg h-100 d-flex flex-column"
              style="min-height: 200px"
            >
              <v-card-title class="px-3 py-1">
                <h6 class="text-caption font-weight-bold">
                  {{ orderModule.order }} Delivered
                </h6>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text
                class="pa-0 d-flex align-center justify-center h-100"
              >
                <div v-if="isOrderStatus">
                  <DoughnutChart
                    :data="ordersLateDelivery"
                    :options="doughnutChartOptions"
                    :height="pieChartHeight"
                    :width="300"
                  />
                </div>
                <div v-else class="h-100 d-flex align-center justify-center">
                  <span class="text-caption"> Data not available </span>
                </div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="6" class="pt-1 px-2">
            <v-card
              elevation="0"
              class="rounded-lg h-100 d-flex flex-column"
              style="min-height: 200px"
            >
              <v-card-title class="px-3 py-1">
                <h6 class="text-caption font-weight-bold">
                  {{ fleetModule.fleet }} Utilization
                </h6>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text
                class="pa-0 d-flex align-center justify-center h-100"
              >
                <div v-if="isFleetUtilization">
                  <TwoBarChart
                    :labels="fleetUtilization.labels"
                    :datasets="fleetUtilization.datasets"
                    :options="fleetUtilizationOption"
                    :height="twoChartHeight"
                    :width="chartsWidth"
                  />
                </div>
                <div v-else class="h-100 d-flex align-center justify-center">
                  <span class="text-caption"> Data not available </span>
                </div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-col>

      <v-col cols="4" class="pl-2 pr-0" v-if="$helper.isCompanyHasItems()">
        <v-card
          elevation="0"
          class="rounded-lg h-100 d-flex flex-column"
          style="min-height: 200px"
        >
          <v-card-title class="px-3 py-1">
            <h6 class="text-caption font-weight-bold">Items</h6>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-0 d-flex align-center justify-center h-100">
            <div v-if="isStorageType">
              <PieChart
                :data="storageType"
                :options="pieChartItemOptions"
                :height="250"
                :width="300"
              />
            </div>
            <div v-else class="pt-14">
              <span class="text-caption"> Data not available </span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="6" class="pl-0 pr-2 pt-1">
        <v-card
          elevation="0"
          class="rounded-lg h-100 d-flex flex-column"
          style="min-height: 200px"
        >
          <v-card-title class="px-3 py-1">
            <h6 class="text-caption font-weight-bold">
              {{ tripModule.trip }} Stats
            </h6>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-0 d-flex align-center justify-center h-100">
            <div v-if="isProjectWise">
              <BarChart
                :data="projectWiseTrip"
                :height="barChartHeight"
                :width="barChartsWidth"
              />
            </div>
            <div v-else class="h-100 d-flex align-center justify-center">
              <span class="text-caption"> Data not available </span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6" class="pl-2 pr-0 pt-1">
        <v-card
          elevation="0"
          class="rounded-lg h-100 d-flex flex-column"
          style="min-height: 200px"
        >
          <v-card-title class="px-3 py-1">
            <h6 class="text-caption font-weight-bold">
              {{ orderModule.order }} Status
            </h6>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-0 d-flex align-center justify-center h-100">
            <div v-if="isOrderStatus">
              <BarChart
                :data="ordersStatusWise"
                :height="barChartHeight"
                :width="barChartsWidth"
              />
            </div>
            <div v-else class="h-100 d-flex align-center justify-center">
              <span class="text-caption"> Data not available </span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <v-col cols="6" class="pl-0 pr-2 pt-1">
        <v-card
          elevation="0"
          class="rounded-lg h-100 d-flex flex-column"
          style="min-height: 200px"
        >
          <v-card-title class="px-3 py-1">
            <h6 class="text-caption font-weight-bold text-capitalize">
              Reason for {{ orderModule.orderPlural }} Not delivered
            </h6>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-0 d-flex align-center justify-center h-100">
            <div v-if="isNotDelivered">
              <BarChart
                :data="notDelivered"
                :height="barChartHeight"
                :width="barChartsWidth"
              />
            </div>
            <div v-else class="h-100 d-flex align-center justify-center">
              <span class="text-caption"> Data not available </span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="6" class="pl-2 pr-0 pt-1">
        <v-card
          elevation="0"
          class="rounded-lg h-100 d-flex flex-column"
          style="min-height: 200px"
        >
          <v-card-title class="px-3 py-1">
            <h6 class="text-caption font-weight-bold text-capitalize">
              Reason for {{ orderModule.orderPlural }} partially delivered
            </h6>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-0 d-flex align-center justify-center h-100">
            <div v-if="isPartialDelivery" class="pt-6">
              <BarChart
                :data="partialDelivered"
                :height="barChartHeight"
                :width="barChartsWidth"
              />
            </div>
            <div v-else class="h-100 d-flex align-center justify-center">
              <span class="text-caption"> Data not available </span>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { bus } from "@/main.js";
import {
  operationalAnalyticsModule,
  orderModule,
  tripModule,
  fleetModule,
  itemModule,
} from "@/utils/moduleMapping";
import BaseDialog from "@/components/BaseComponents/BaseDialog.vue";
import { returnToday } from "@/utils/functions";
export default {
  components: { BaseDialog },
  props: {
    filters: {
      type: Object,
      default: {},
    },
    tabs: {
      type: Number,
    },
  },

  data() {
    return {
      tripModule,
      orderModule,
      fleetModule,
      itemModule,
      todayDate: returnToday(),
      projectWiseTripLabels: [],
      projectWiseTrip: null,
      tripAnalytics: {},

      isTripStats: false,
      isProjectWise: false,
      tripAnalyticsIcons: {
        total_trips: "mdi-map-marker-path",
        total_orders: "mdi-archive",
        payment_collection: "mdi-currency-usd",
        driver_utilization: "mdi-card-account-details",
        vehicle_utilization: "mdi-tanker-truck",
      },
      tripAnalyticsColor: {
        total_trips: "trip_active",
        total_orders: "primary",
        payment_collection: "partially_delivered",
        driver_utilization: "error",
        vehicle_utilization: "on_hold",
      },
      tripAnalyticsObject: {},
      isOrderStatus: false,
      ordersStatusWise: null,
      ordersStatusWiseLabels: [],

      lateDeliveredInfo: null,
      ordersLateDelivery: null,
      lateDeliveredLabels: [],

      averageDelayTime: null,

      isPartialDelivery: false,
      isNotDelivered: false,
      partialDelivered: null,
      notDelivered: null,
      notDeliveredLabels: [],

      showNotDeliveredChart: false,

      isFleetUtilization: false,
      fleetUtilization: null,
      fleetUtilizationOption: {
        legend: {
          labels: {
            usePointStyle: true,
            boxWidth: 8,
          },
        },
        scales: {
          xAxes: [{}],
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                min: 0,
                max: 100,
                stepSize: 25,
                callback: function (value, index, values) {
                  return value + " % ";
                },
              },
            },
          ],
        },
      },

      pieChartOptions: {
        responsive: true,
        maintainAspectRatio: true,
        legend: {
          boxWidth: 10,
          display: true,
          maxWidth: 400,
          align: "center",
          textAlign: "start",
          position: "right",
        },
      },
      pieChartItemOptions: {
        responsive: true,
        maintainAspectRatio: true,
        legend: {
          display: true,
          position: "bottom",
        },
      },
      doughnutChartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        animation: {
          animateRotate: false,
        },
        legend: {
          boxWidth: 20,
          display: true,
          textAlign: "end",
          position: "right",
        },
      },

      isStorageUtilization: false,
      isStorageType: false,
      storageUtilization: null,
      storageType: null,
      userDetails: this.$helper.getUserDetailsLocalStorage(),
    };
  },
  computed: {
    pieChartHeight() {
      return parseInt(this.$refs.tripCharts?.offsetHeight - 200) / 3;
    },
    twoChartHeight() {
      return parseInt(this.$refs.tripCharts?.offsetHeight - 100) / 3;
    },
    barChartHeight() {
      return 300;
    },
    chartsWidth() {
      return parseInt(this.$refs.tripCharts?.offsetWidth - 50) / 3;
    },
    barChartsWidth() {
      return parseInt(this.$refs.tripCharts?.offsetWidth - 50) / 2;
    },
  },
  watch: {
    tabs(val) {
      if (val == 1) {
        this.getTripAnalytics();
        this.getTripStats();
        this.getOrderStatus();
        this.getReasonIncompleteDelivery();
        this.getFleetUtilization();
        this.getStorageUtilization();
      }
    },
  },
  methods: {
    getStorageUtilization(params = {}) {
      params = {
        ...params,
        date: this.todayDate,
        ...this.filters,
      };

      this.isStorageUtilization = false;
      this.isStorageType = false;
      bus.$emit("showLoader", true);
      this.$api.newOperation
        .getStorageUtilization(params)
        .then((res) => {
          bus.$emit("showLoader", false);
          this.storageUtilization = res.data.storage_utilization;
          this.storageType = res.data.storage_type;

          setTimeout(() => {
            this.isStorageUtilization = res.data?.storage_utilization
              ? true
              : false;
            this.isStorageType = res.data?.storage_type ? true : false;
          }, 100);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    getFleetUtilization(params = {}) {
      params = {
        ...params,
        date: this.todayDate,
        ...this.filters,
      };
      this.isFleetUtilization = false;
      bus.$emit("showLoader", true);
      this.$api.newOperation
        .getFleetUtilization(params)
        .then((res) => {
          bus.$emit("showLoader", false);
          this.fleetUtilization = res.data.fleet_utilization;

          setTimeout(() => {
            this.isFleetUtilization = res.data?.fleet_utilization
              ? true
              : false;
          }, 100);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    getReasonIncompleteDelivery(params = {}) {
      params = {
        ...params,
        date: this.todayDate,
        ...this.filters,
      };

      this.isPartialDelivery = false;
      this.isNotDelivered = false;
      bus.$emit("showLoader", true);
      this.$api.newOperation
        .getReasonIncompleteDelivery(params)
        .then((res) => {
          bus.$emit("showLoader", false);
          this.partialDelivered = res.data.partial_deliver_reason;
          this.notDelivered = res.data.not_delivery_reason;
          setTimeout(() => {
            this.isPartialDelivery = res.data?.partial_deliver_reason
              ? true
              : false;
            this.isNotDelivered = res.data?.not_delivery_reason ? true : false;
          }, 100);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    getOrderStatus(params = {}) {
      params = {
        ...params,
        date: this.todayDate,
        ...this.filters,
      };

      this.isOrderStatus = false;
      this.isLateDeliveredInfo = false;
      bus.$emit("showLoader", true);
      this.$api.newOperation
        .getOrderStatus(params)
        .then((res) => {
          bus.$emit("showLoader", false);
          this.ordersStatusWise = res.data.orders_status_wise;
          this.ordersLateDelivery = res.data.late_delivered_info;
          setTimeout(() => {
            this.isOrderStatus = res.data?.orders_status_wise ? true : false;
            this.isLateDeliveredInfo = res.data?.late_delivered_info
              ? true
              : false;
          }, 100);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    getTripStats(params = {}) {
      params = {
        ...params,
        date: this.todayDate,
        ...this.filters,
      };

      this.isProjectWise = false;
      this.isTripStats = false;
      bus.$emit("showLoader", true);
      this.$api.newOperation
        .getTripStats(params)
        .then((res) => {
          bus.$emit("showLoader", false);
          this.projectWiseTrip = res.data.trip_status_wise;
          this.timeWiseData = res.data.trip_time_breakdown;

          // this.timeWiseData = {
          //   data: {
          //     labels: ["Break Time", "Traveling Time", "Processing Time"],
          //     datasets: [
          //       {
          //         label: "My First Dataset",
          //         data: [300, 50, 100],
          //         backgroundColor: [
          //           "rgb(255, 99, 132)",
          //           "rgb(54, 162, 235)",
          //           "rgb(255, 205, 86)",
          //         ],
          //         hoverOffset: 4,
          //       },
          //     ],
          //   },
          //   options: this.pieChartOptions,
          // };
          setTimeout(() => {
            this.isProjectWise = res.data?.trip_status_wise ? true : false;
            this.isTripStats = res.data?.trip_time_breakdown ? true : false;
          }, 100);
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
    getTripAnalytics(params = {}) {
      params = {
        ...params,
        date: this.todayDate,
        ...this.filters,
      };
      bus.$emit("showLoader", true);
      this.$api.newOperation
        .getTripAnalytics(params)
        .then((res) => {
          bus.$emit("showLoader", false);

          this.tripAnalytics = res.data;
          console.log(this.tripAnalytics);
          if (
            this.tripAnalytics &&
            Object.keys(this.tripAnalytics).length > 0
          ) {
            this.tripAnalyticsObject = {
              total_trips: this.tripAnalytics.total_trips,
              total_orders: this.tripAnalytics.total_orders,
              payment_collection: `${this.tripAnalytics.total_collected_payment}/${this.tripAnalytics.total_payment}`,
              driver_utilization: `${this.tripAnalytics.total_utilized_drivers}/${this.tripAnalytics.total_drivers}`,
              vehicle_utilization: `${this.tripAnalytics.total_utilized_vehicles}/${this.tripAnalytics.total_vehicles}`,
            };
          }
        })
        .catch((err) => {
          console.error(err);
          bus.$emit("showLoader", false);
        });
    },
  },
  mounted() {
    this.getTripAnalytics();
    this.getTripStats();
    this.getOrderStatus();
    this.getReasonIncompleteDelivery();
    this.getFleetUtilization();
    this.getStorageUtilization();
  },
};
</script>

<style scoped>
.app-grid {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
  grid-gap: 14px;
}

/* @media screen and (max-width: 1600px) {
  .chartHeight {
    height: 360px;
  }
}

@media screen and (max-width: 1400px) {
  .chartHeight {
    height: 360px;
  }
} */
</style>
